(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.infra.controller
  (:require
    [frontend.ui.component.lp-portal.report.body.private-equity.fund.controller :as pe-controller]
    [frontend.ui.component.lp-portal.report.overview.big-figures.controller :as big-figures]
    [frontend.ui.component.lp-portal.report.overview.historical-net-cash-flows-chart.controller
     :refer [historical-net-cash-flows]]
    [frontend.ui.component.lp-portal.report.overview.portfolio-at-fair-value.controller
     :refer [portfolio-at-fair-value]]
    [frontend.ui.component.lp-portal.report.overview.total-investment-chart.controller
     :refer [total-investment]]
    [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.controller
     :refer [largest-investments-at-fair-value]]
    [frontend.ui.component.lp-portal.report.tearsheet.portfolio-by-country-at-fair-value.controller
     :refer [portfolio-by-country-at-fair-value]]
    [frontend.ui.component.lp-portal.report.tearsheet.return-development.controller
     :refer [tvpi]]
    [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn- tearsheet-data
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  {:tvpi (report-ctl/with-footnote
          props
          :tvpi-footnotes
          (tvpi (get-in report-data [:tearsheet :tvpi])
                {}))
   :return-development (report-ctl/with-footnote
                        props
                        :return-development-footnotes
                        (get-in report-data [:tearsheet :return-development]))

   :largest-investments-at-fair-value (report-ctl/with-footnote
                                       props
                                       :largest-investments-footnotes
                                       (largest-investments-at-fair-value
                                        (get-in report-data
                                                [:tearsheet :largest-investments-at-fair-value])))
   :portfolio-by-country-at-fair-value nil
   ;; Infra team does not want to show this graph
   #_(report-ctl/with-footnote
      props
      :portfolio-by-country-footnotes
      (portfolio-by-country-at-fair-value
       (get-in report-data
               [:tearsheet :portfolio-by-country-at-fair-value])))
   :basic-information-primary (report-ctl/with-footnote
                               props
                               :basic-information-primary-footnotes
                               (get-in report-data
                                       [:basic-information-primary]))
   :basic-information-secondary (report-ctl/with-footnote
                                 props
                                 :basic-information-secondary-footnotes
                                 (get-in report-data [:basic-information-secondary]))

   ;; TODO boxi basic info and credit basic info XLSX are specific (compared to buyout-x and infra
   ;; which are identical). Ask CapMan what they want precisely for all.
  })

(defn- overview
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  {:overview-figures          (report-ctl/with-footnote props
                                                        :overview-figures-footnotes
                                                        (big-figures/summary-figures report-data))
   :recent-development-text   (report-ctl/rich-content props
                                                       :recent-development-text)
   :recent-development        (report-ctl/with-footnote props
                                                        :recent-development-footnotes
                                                        (:fund-figures report-data))
   :total-investment          (report-ctl/with-footnote props
                                                        :total-investment-footnotes
                                                        (total-investment (get-in report-data
                                                                                  [:chart-data
                                                                                   :at-cost])))
   :portfolio-at-fair-value   (report-ctl/with-footnote props
                                                        :portfolio-at-fair-value-footnotes
                                                        (portfolio-at-fair-value
                                                         (get-in report-data
                                                                 [:chart-data :fair-value])))
   :historical-net-cash-flows (report-ctl/with-footnote props
                                                        :historical-net-cashflows-footnotes
                                                        (historical-net-cash-flows
                                                         (get-in report-data
                                                                 [:chart-data :table])))})

(defn- details-and-figures
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  {:current-portfolio     (report-ctl/with-footnote
                           props
                           :current-portfolio-footnotes
                           (get-in report-data [:current-portfolio]))
   :exited-portfolio      (report-ctl/with-footnote
                           props
                           :exited-portfolio-footnotes
                           (get-in report-data [:exited-portfolio]))
   :investment-summary    (report-ctl/with-footnote
                           props
                           :investment-summary-footnotes
                           (:investment-summary report-data))
   :cash-flows-and-assets (report-ctl/with-footnote
                           props
                           :cash-flows-and-assets-footnotes
                           (get-in report-data
                                   [:cash-flows-and-assets]))})

(defn- esg
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  (let [{:keys [esg]} report-data]
    {:esg-targets-and-strategy-text (report-ctl/rich-content props
                                                             :esg-targets-and-strategy-text)
     :key-perf-indicators (->> (report-ctl/with-footnote props
                                                         :key-perf-indicators-footnotes
                                                         esg)
                               (report-ctl/with-editable-tables props :key-perf-indicators
                                                                pe-controller/raw-data->editable-data
                                                                pe-controller/editable-data->raw-data))
     :gresb                         (get-in report-data [:esg :gresb])
     :incidents-text                (report-ctl/rich-content props :incidents-text)}))

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name           (:fund-name report-data)
   :reference-date      (get-in report-data [:reference-date])
   :tearsheet           (tearsheet-data (update props :dynamic-path concat [:tearsheet]))
   :overview            (overview (update props :dynamic-path concat [:overview]))
   :details-and-figures (details-and-figures
                          (update props :dynamic-path concat [:details-and-figures]))
   :esg                 (esg (update props :dynamic-path concat [:esg]))
   :investors           (report-ctl/with-footnote props
                                                  :investors-footnotes
                                                  (:investors report-data))
   :summaries           {:finance-summary   (report-ctl/with-footnote
                                             props
                                             :finance-summary-footnotes
                                             (:finance-summary report-data))
                         :finance-summary-2 (report-ctl/with-footnote
                                             props
                                             :finance-summary-2-footnotes
                                             (:finance-summary-2 report-data))}})
